import Phaser from "phaser";

export class CoinSprite extends Phaser.GameObjects.Sprite {
  /** Preload coin spritesheet; call during Scene.preload() */
  public static preload(scene: Phaser.Scene) {
    if (scene.textures.exists("coin")) return;

    scene.load.spritesheet("coin", "/assets/misc/coin.png", {
      frameWidth: 128,
      frameHeight: 128,
      endFrame: 4, // 5 frames total 0–4
    });
  }

  /** Create spin animation if not yet present; call during Scene.create() */
  public static createAnimation(scene: Phaser.Scene) {
    if (scene.anims.exists("coin-spin")) return;

    scene.anims.create({
      key: "coin-spin",
      frames: scene.anims.generateFrameNumbers("coin", {
        start: 0,
        end: 4,
      }),
      frameRate: 10,
      repeat: -1,
    });
  }

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, "coin");
    scene.add.existing(this);
    this.setScale(0.15);

    if (scene.anims.exists("coin-spin")) {
      this.play({ key: "coin-spin", repeat: -1 });
    }
  }
}
